import { DataTypeColumn } from '../../Common/commonColumnHelpers'
import { LodgingChain } from 'models/google_place_chain'
import { GooglePlaceDoorBase } from 'models/google_place_door'
import { getGooglePlaceDoorBaseColumns } from '../GooglePlaceBase/GooglePlaceDoorsBaseColumnsInfo'

export const CONVENIENCE_DOORS_COLUMNS = getGooglePlaceDoorBaseColumns(
  'Convenience'
) satisfies Partial<
  Record<keyof GooglePlaceDoorBase | keyof LodgingChain, DataTypeColumn>
>
